class SaveActivationCodeDto {
  active!: boolean;
}

export default SaveActivationCodeDto;
